export default __webpack_public_path__ + "static/media/rocket_anim_95.4d1a34b3.png";